import React from 'react';
import TypeFilter, { TypeFilterChildProps, TypeFilterRenderProps } from './TypeFilter';
import { useIntl } from 'react-intl';
import Pill from 'ui/Pill/Pill';
import useIsRtl from 'hooks/useIsRtl';
import PlainList from 'ui/PlainList/PlainList';
import ListItem from 'ui/PlainList/ListItem';

const PillTypeFilter = (props: TypeFilterChildProps) => {
  const { formatMessage } = useIntl();
  const isRtl = useIsRtl();

  return (
    <TypeFilter {...props}>
      {({ onApplyFilter, options, filterState }: TypeFilterRenderProps) => {
        return (
          <PlainList
            ariaLabelledBy={props.id ? props.id : ''}
            style={{
              display: 'inline-flex',
              flexWrap: 'wrap',
              listStyleType: 'none',
              margin: '1rem 0',
              padding: 0
            }}
          >
            {options.map(({ id, name, types }) => (
              <ListItem
                key={id}
                style={{ margin: isRtl ? '0 0 0 1rem' : '0 1rem 0 0', marginBottom: '1rem' }}
              >
                <Pill
                  label={formatMessage({ id: name })}
                  onClick={() => onApplyFilter(types)}
                  selected={filterState[id] && filterState[id].length > 0}
                />
              </ListItem>
            ))}
          </PlainList>
        );
      }}
    </TypeFilter>
  );
};

export default PillTypeFilter;
